import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import Nav from "../../components/Nav/Nav";
import Footer from "../../components/Footer/Footer";
import styles from "./WheelOfFortune.module.css";
import Wheel from "../../components/Wheel/Wheel";
import GoogleFormEmbed from "../../components/GoogleFormEmbed/GoogleFormEmbed";

const WheelOfFortune: React.FC = () => {
  const { t } = useTranslation();
  const [prize, setPrize] = useState<string | null>(null);
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const formRef = useRef<HTMLDivElement | null>(null);

  const items = [
    "Limpeza Carpet",
    "Limpeza Sofá",
    "Limpeza Colchão",
    "Estadia de Férias",
    "Tente novamente",
  ];

  const getPreFilledFormUrl = (prize: string) => {
    const entryId = "entry.342216926"; // Prize field
    const baseFormUrl =
      "https://docs.google.com/forms/d/e/1FAIpQLSeoUo9ZDwdjB2a_a1IGbh8E8lQekgjsJsa4CxOD_97hPGgdIg/viewform?embedded=true";
    return `${baseFormUrl}&${entryId}=${encodeURIComponent(prize)}`;
  };

  const handleFinish = (winner: string) => {
    if (winner !== "Tente novamente") {
      setPrize(winner);
      setAlertMessage(t("wheel_page.you_won", { prize: winner }));

      // Scroll to the form smoothly
      setTimeout(() => {
        formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 300);
    } else {
      setAlertMessage(t("wheel_page.try_again"));
    }
  };

  useEffect(() => {
    if (!alertMessage) return;
    const timer = setTimeout(() => setAlertMessage(null), 3000);
    return () => clearTimeout(timer);
  }, [alertMessage]);

  return (
    <>
      <Nav />
      <hr />
      <div className={styles.contactSection}>
        <h2>{t("wheel_page.wheel_title")}</h2>
        <Wheel segments={items} onFinished={handleFinish} />
      </div>

      {prize && (
        <div className={styles.contactSection} ref={formRef}>
          {alertMessage && <div className={styles.alert}>{alertMessage}</div>}

          <GoogleFormEmbed formUrl={getPreFilledFormUrl(prize)} />
        </div>
      )}

      <Footer />
    </>
  );
};

export default WheelOfFortune;
